/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
// import _ from "lodash";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTrainingDocuments, showModal, getFile } from "actions";
import "components/widgets/training/TrainingDetail.css";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";

class TrainingDetailDocuments extends Component {
  state = { trainingDetailDocs: null };

  componentDidMount() {
    console.dir(this.props);
    this.props.getTrainingDocuments(
      this.props.trainingId,
      this.onBeginDocs,
      this.onSuccessDocs,
      this.onErrorDocs
    );
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.training !== prevProps.training) {
      // console.dir(this.props);
      this.fetchDocs();
    }
  };

  fetchDocs = () => {
    this.props.getTrainingDocuments(
      this.props.trainingId,
      this.onBeginDocs,
      this.onSuccessDocs,
      this.onErrorDocs
    );
  };

  onBeginDocs = () => {};
  onSuccessDocs = (res) => {
    this.props.onProcessEnd();
    this.setState({ trainingDetailDocs: res });
  };
  onErrorDocs = (e) => {
    this.props.onProcessEnd();
    console.dir(e);
  };

  onBeginDownloadDoc = () => {
    this.props.onProcessBegin();
  };
  onSuccessDownloadDoc = (res, headers) => {
    // console.dir(res);
    this.props.onProcessEnd();
    this.viewOrDownload(URL.createObjectURL(res.raw.data), headers);
  };
  onErrorDownloadDoc = (e) => {
    this.props.onProcessEnd();
    console.dir(e);
  };

  viewOrDownload = (href, headers) => {
    debugger
    let filename = "unknownfile";
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(headers["content-disposition"]);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }

    // if (filename.toLowerCase().includes(".pdf")) {
    //   //to View
    //   this.props.sendToViewerTab(href);
    // } else {
    //   // to download
    //   let a = window.document.createElement("a");
    //   a.setAttribute("href", href);
    //   a.setAttribute("target", "_blank");
    //   a.setAttribute("download", filename);
    //   window.document.body.appendChild(a);
    //   a.click();
    //   window.document.body.removeChild(a);
    // }
    
    //download
    let a = window.document.createElement("a");
      a.setAttribute("href", href);
      a.setAttribute("target", "_blank");
      a.setAttribute("download", filename);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
  };

  downloadExternalLink = (link) => {
    let a = window.document.createElement("a");
    a.setAttribute("href", link);
    a.setAttribute("target", "_blank");
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  }

  showDetail = (doc) => {
    if (doc.fileSource === "Dynamics") {
      this.props.getFile(
        doc.fileURL,
        this.onBeginDownloadDoc,
        this.onSuccessDownloadDoc,
        this.onErrorDownloadDoc,
        false
      );
    } else {
      this.downloadExternalLink(doc.fileURL);
    }
  };

  renderDocuments = () => {
    // console.dir(this.state.trainingDetailDocs);

    if (!this.state.trainingDetailDocs) return null;

    return this.state.trainingDetailDocs.map((doc) => {
      //console.dir(doc);
      return (
        <div key={doc.fileURL} className="trdoc_doc">
          <SvgViewDocuments
            onClick={() => this.showDetail(doc)}
            // onClick={this.props.sendToViewerTab}
            className="training-table__icon-viewdoc"
          />
          <span>{doc.name}</span>
        </div>
      );
    });
  };

  render() {
    return (
      <>
        {this.props.spinner}
        <div className="trainingDocumentsContainer">
          {this.renderDocuments()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modal: state.modal,
    aplication: state.aplication,
  };
};

export default connect(mapStateToProps, {
  getTrainingDocuments,
  showModal,
  getFile,
})(containsLongRunningProcess(TrainingDetailDocuments));
